import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider, useSelector } from 'react-redux';
import { store } from './redux/store';

import Login from './components/Auth/Login';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import Dashboard from './components/Dashboard/Dashboard';
import NewsPage from './components/News/NewsPage';
import PayoutPage from './components/Payout/PayoutPage';
import ExportPage from './components/Export/ExportPage';
import AnalyticsPage from './components/Dashboard/Analytics/AnalyticsPage';
import NotFound from './components/NotFound';


function ThemedApp() {
  const darkMode = useSelector(state => state.theme.darkMode);
  return (
    <div className={darkMode ? 'dark' : ''}>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/news" element={<ProtectedRoute><NewsPage /></ProtectedRoute>} />
          <Route path="/payouts" element={<ProtectedRoute><PayoutPage /></ProtectedRoute>} />
          <Route path="/export" element={<ProtectedRoute><ExportPage /></ProtectedRoute>} />
          <Route path="/analytics" element={<ProtectedRoute><AnalyticsPage /></ProtectedRoute>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </div>
  );
}

const App = () => (
  <Provider store={store}>
    <ThemedApp />
  </Provider>
);

export default App;
